/**
 * Centralized spacing utilities
 * Maps schema tokens to Tailwind classes
 */

/**
 * Padding mapping for section-level spacing
 * Keys match schema options, values are Tailwind classes
 */
export const paddingMapping: Record<string, string> = {
    'pt-0': 'pt-0',
    'pt-8': 'pt-8',
    'pt-16': 'pt-16',
    'pt-24': 'pt-24',
    'pt-32': 'pt-32',
    'pb-0': 'pb-0',
    'pb-8': 'pb-8',
    'pb-16': 'pb-16',
    'pb-24': 'pb-24',
    'pb-32': 'pb-32',
};

/**
 * Get padding class with fallback
 */
export function getPaddingClass(padding: string | undefined, fallback: string = 'pt-16'): string {
    if (!padding) return fallback;
    return paddingMapping[padding] || fallback;
}

/**
 * Default section padding values
 */
export const defaultPadding = {
    top: 'pt-16',
    bottom: 'pb-16',
};
